export default __webpack_public_path__ + "static/media/icon_disclosure-arrow-up.c2353154.svg";